<template>
  <div>
    <!-- 全屏拦截页 -->
    <div v-if="visible && state.showBlockOverlay" class="youth-block-overlay">
      <div class="youth-block-card">
        <div class="youth-block-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
        </div>
        <h2>已限制访问</h2>
        <p class="youth-block-reason">{{ state.blockReason }}</p>
        <div class="youth-block-stats">
          <div class="stat-row">
            <span>今日已用</span>
            <span class="stat-value">{{ state.usageMinutes }} / {{ state.dailyTimeLimit }} 分钟</span>
          </div>
        </div>
        <button class="youth-unlock-btn" @click="showPasswordModal = true">
          验证密码继续使用
        </button>
        <p class="youth-block-hint">验证后可使用30分钟</p>
      </div>
    </div>

    <!-- 连续使用30分钟休息提醒（《移动互联网未成年人模式建设指南》要求） -->
    <div v-if="visible && state.showRestReminder && !state.showBlockOverlay" class="youth-rest-overlay">
      <div class="youth-rest-card">
        <div class="youth-rest-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2"/></svg>
        </div>
        <h3>休息一下，保护视力</h3>
        <p class="youth-rest-text">你已连续使用 {{ state.continuousMinutes }} 分钟，建议远眺放松或做眼保健操，休息后再回来继续阅读。</p>
        <button class="youth-rest-btn" @click="acknowledgeRest">好的，休息一下</button>
      </div>
    </div>

    <!-- 内容不在适龄内容池提示（青少年模式内容过滤） -->
    <div v-if="visible && state.showContentBlocked" class="youth-rest-overlay">
      <div class="youth-rest-card">
        <div class="youth-rest-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
        </div>
        <h3>该内容不在适龄内容池</h3>
        <p class="youth-rest-text">青少年模式已开启，为保护未成年人身心健康，仅展示适龄内容池内的作品。如需访问全部内容，请由监护人验证后关闭青少年模式。</p>
        <button class="youth-rest-btn" @click="backHomeFromBlocked">返回首页</button>
      </div>
    </div>

    <!-- 密码验证弹窗 -->
    <div v-if="visible && showPasswordModal" class="youth-password-overlay" @click="closePasswordModal">
      <div class="youth-password-modal" @click.stop>
        <h3>验证青少年模式密码</h3>
        <div class="youth-password-input-group">
          <input
            ref="pinInput0"
            v-model="pin[0]"
            type="tel"
            maxlength="1"
            class="pin-input"
            @input="onPinInput(0)"
            @keydown.delete="onPinDelete(0)"
          />
          <input
            ref="pinInput1"
            v-model="pin[1]"
            type="tel"
            maxlength="1"
            class="pin-input"
            @input="onPinInput(1)"
            @keydown.delete="onPinDelete(1)"
          />
          <input
            ref="pinInput2"
            v-model="pin[2]"
            type="tel"
            maxlength="1"
            class="pin-input"
            @input="onPinInput(2)"
            @keydown.delete="onPinDelete(2)"
          />
          <input
            ref="pinInput3"
            v-model="pin[3]"
            type="tel"
            maxlength="1"
            class="pin-input"
            @input="onPinInput(3)"
            @keydown.delete="onPinDelete(3)"
          />
        </div>
        <p v-if="pinError" class="pin-error">{{ pinError }}</p>
        <div class="youth-password-actions">
          <button class="cancel-btn" @click="closePasswordModal">取消</button>
          <button class="confirm-btn" :disabled="pinComplete ? false : true" @click="submitPassword">
            验证
          </button>
        </div>
      </div>
    </div>

    <!-- 顶部提示条 -->
    <div
      v-if="visible && state.enabled && !state.showBlockOverlay"
      class="youth-float-indicator"
      @click="showPasswordModal = true"
    >
      <span class="youth-float-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
      </span>
      <span class="youth-float-label">青少年模式已开启</span>
      <span class="youth-float-divider"></span>
      <span class="youth-float-time">{{ remainingText }}</span>
    </div>
  </div>
</template>

<script>
import youthModeManager from '@/utils/youthMode';

export default {
  name: 'YouthModeOverlay',
  data() {
    return {
      state: youthModeManager.state,
      visible: false,
      showPasswordModal: false,
      pin: ['', '', '', ''],
      pinError: '',
      submitting: false,
    }
  },
  computed: {
    pinComplete() {
      return this.pin.every(d => d !== '');
    },
    remainingText() {
      if (this.state.unlocked) return '已解锁';
      const remaining = this.state.dailyTimeLimit - this.state.usageMinutes;
      if (remaining <= 0) return '已用完';
      return `剩余${remaining}分钟`;
    }
  },
  created() {
    this.unsubscribe = youthModeManager.onStateChange((newState) => {
      this.state = { ...newState };
      this.updateBodyPadding();
    });
    setTimeout(() => {
      this.visible = true;
    }, 100);
  },
  mounted() {
    youthModeManager.init();
  },
  beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    youthModeManager.destroy();
    document.body.classList.remove('youth-mode-bar-active');
  },
  methods: {
    updateBodyPadding() {
      if (this.state.enabled && !this.state.showBlockOverlay) {
        document.body.classList.add('youth-mode-bar-active');
      } else {
        document.body.classList.remove('youth-mode-bar-active');
      }
    },
    onPinInput(index) {
      if (this.pin[index] && index < 3) {
        const nextRef = 'pinInput' + (index + 1);
        this.$nextTick(() => {
          if (this.$refs[nextRef]) {
            this.$refs[nextRef].focus();
          }
        });
      }
      this.pinError = '';
      if (this.pinComplete) {
        this.submitPassword();
      }
    },
    onPinDelete(index) {
      if (!this.pin[index] && index > 0) {
        const prevRef = 'pinInput' + (index - 1);
        this.$nextTick(() => {
          if (this.$refs[prevRef]) {
            this.$refs[prevRef].focus();
          }
        });
      }
      this.pinError = '';
    },
    closePasswordModal() {
      this.showPasswordModal = false;
      this.pin = ['', '', '', ''];
      this.pinError = '';
    },
    acknowledgeRest() {
      youthModeManager.acknowledgeRest();
    },
    backHomeFromBlocked() {
      youthModeManager.dismissContentBlocked();
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
    async submitPassword() {
      if (this.submitting) return;
      this.submitting = true;
      this.pinError = '';

      try {
        const result = await youthModeManager.unlockWithPassword(this.pin.join(''));
        if (result.success) {
          this.closePasswordModal();
        } else {
          this.pinError = result.message || '密码错误';
          this.pin = ['', '', '', ''];
          this.$nextTick(() => {
            if (this.$refs.pinInput0) this.$refs.pinInput0.focus();
          });
        }
      } catch (e) {
        this.pinError = '验证失败，请稍后重试';
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
.youth-block-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.youth-block-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 48px 40px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
}

.youth-block-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  color: var(--brand);
}
.youth-block-icon svg {
  width: 100%;
  height: 100%;
}

.youth-block-card h2 {
  color: var(--brand);
  font-size: 24px;
  margin: 0 0 12px 0;
}

.youth-block-reason {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.youth-block-stats {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.stat-row {
  display: flex;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.stat-value {
  color: var(--brand);
  font-weight: 600;
}

.youth-unlock-btn {
  width: 100%;
  padding: 14px;
  background: var(--brand);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--t-fast), transform var(--t-fast);
}

.youth-unlock-btn:hover {
  transform: translateY(-2px);
  background: var(--brand-hover);
}

.youth-block-hint {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  margin-top: 12px;
}

.youth-password-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(12, 25, 41, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.youth-password-modal {
  background: linear-gradient(180deg, #1a2f4a 0%, #0f1c2e 100%);
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 16px;
  padding: 32px;
  max-width: 360px;
  width: 90%;
  text-align: center;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.55);
}

.youth-password-modal h3 {
  color: var(--text);
  margin: 0 0 24px 0;
  font-size: 18px;
}

.youth-password-input-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 16px;
}

.pin-input {
  width: 52px;
  height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  background: var(--surface-3);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s;
}

.pin-input:focus {
  border-color: var(--brand);
}

.pin-error {
  color: var(--danger);
  font-size: 14px;
  margin: 0 0 16px 0;
}

.youth-password-actions {
  display: flex;
  gap: 12px;
}

.youth-password-actions .cancel-btn,
.youth-password-actions .confirm-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.youth-password-actions .cancel-btn {
  background: var(--surface-3);
  color: var(--text-dim);
  border: 1px solid var(--border);
}

.youth-password-actions .cancel-btn:hover {
  background: var(--brand-soft);
  border-color: var(--brand);
}

.youth-password-actions .confirm-btn {
  background: var(--brand);
  color: white;
}

.youth-password-actions .confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.youth-password-actions .confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.youth-float-indicator {
  position: fixed;
  top: var(--nav-h);
  left: 0;
  right: 0;
  height: 36px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1001;
  cursor: pointer;
  transition: background 0.2s;
}

.youth-float-indicator:hover {
  background: var(--surface-2);
}

.youth-float-icon {
  width: 18px;
  height: 18px;
  color: var(--brand);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.youth-float-icon svg {
  width: 100%;
  height: 100%;
}

.youth-float-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

.youth-float-divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.2);
}

.youth-float-time {
  font-size: 13px;
  color: var(--brand);
  font-weight: 600;
}

/* 连续使用休息提醒 */
.youth-rest-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(12, 25, 41, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

.youth-rest-card {
  background: linear-gradient(180deg, #1a2f4a 0%, #0f1c2e 100%);
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 16px;
  padding: 36px 32px;
  max-width: 380px;
  width: 90%;
  text-align: center;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.55);
}

.youth-rest-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 14px;
  color: var(--brand);
}

.youth-rest-icon svg {
  width: 100%;
  height: 100%;
}

.youth-rest-card h3 {
  color: var(--text);
  font-size: 19px;
  margin: 0 0 10px 0;
}

.youth-rest-text {
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  line-height: 1.7;
  margin: 0 0 22px 0;
}

.youth-rest-btn {
  width: 100%;
  padding: 13px;
  background: var(--brand);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--t-fast), transform var(--t-fast);
}

.youth-rest-btn:hover {
  transform: translateY(-1px);
  background: var(--brand-hover);
}
</style>